import { MutableRefObject } from 'react';
import { convertColWidthsGUtoPx } from '../../dataUtils/columnSize/tableColWidthConversionUtils';

import { applyManualColumnWidths } from './hotTableManualColumnResizeApplyUtils';
import { getColWidthsInList } from './hotTableColWidthInListUtils';
import { MNHotInstance } from '../../../../bridge/tableHotInstanceTypes';

type SyncHotTableColWidthsToContainerArgs = {
    hotInstance: MNHotInstance | null | undefined;
    tableContentColWidthsGU: number[] | undefined;
    gridSize: number;
    inList: string | undefined;
    hotTableContainerRef: MutableRefObject<HTMLDivElement | null>;
    getContextZoomScale: () => number;
};

/**
 * Keeps Handsontable's manual column widths aligned with the current container width.
 */
export const syncHotTableColWidthsToContainer = ({
    hotInstance,
    tableContentColWidthsGU,
    gridSize,
    inList,
    hotTableContainerRef,
    getContextZoomScale,
}: SyncHotTableColWidthsToContainerArgs): void => {
    if (!hotInstance || !tableContentColWidthsGU) return;

    const resizeToWidth = getColWidthsInList(inList, hotTableContainerRef, getContextZoomScale);
    const tableContentColWidthsPx = convertColWidthsGUtoPx(tableContentColWidthsGU, gridSize, resizeToWidth);

    if (!tableContentColWidthsPx) return;

    const columnWidthChanges: Array<{ column: number; widthPx: number }> = [];

    tableContentColWidthsPx.forEach((colWidthPx, index) => {
        const currentColWidthPx = hotInstance.getColWidth(index);

        if (currentColWidthPx === colWidthPx) return;

        columnWidthChanges.push({ column: index, widthPx: colWidthPx });
    });

    applyManualColumnWidths(hotInstance, columnWidthChanges);
};
